
(function () {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  //I'm adding this section so I don't have to keep updating this pen every year :-)
  //remove this if you don't need it
  let today = new Date(),
    dd = String(today.getDate()).padStart(2, "0"),
    mm = String(today.getMonth() + 1).padStart(2, "0"),
    yyyy = today.getFullYear(),
    nextYear = yyyy + 1,
    dayMonth = "12/31/",
    birthday = dayMonth + yyyy;

  today = mm + "/" + dd + "/" + yyyy;
  if (today > birthday) {
    birthday = dayMonth + nextYear;
  }
  //end

  // Check if the element with id "countdown" exists
  var countdownDiv = document.getElementById("countdown");

  const countDown = new Date(birthday).getTime();
  if (countdownDiv !== null) {
    console.log("#countdown exists in the DOM");
    const x = setInterval(function () {
      const now = new Date().getTime(),
        distance = countDown - now;

      (document.getElementById("days").innerText = Math.floor(distance / day)),
        (document.getElementById("hours").innerText = Math.floor(
          (distance % day) / hour
        )),
        (document.getElementById("minutes").innerText = Math.floor(
          (distance % hour) / minute
        )),
        (document.getElementById("seconds").innerText = Math.floor(
          (distance % minute) / second
        ));

      //do something later when date is reached
      if (distance < 0) {
        document.getElementById("headline").innerText = "Giveaway Ends!";
        document.getElementById("countdown").style.display = "none";
        document.getElementById("content").style.display = "block";
        clearInterval(x);
      }
      //seconds
    }, 0);
  }
})();

$().ready(function () {
  $(".slick-carousel").slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,

    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        },
      },
    ],
  });
  
  $('.slick-carousel-video').slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    infinite: true,

    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
    ]
  });

  $(".custom_featured_product .product_data .product_gallery").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  });

  $(".magnific_YT_video").magnificPopup({
    type: "iframe",
    closeOnBgClick: false,
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        '<div class="mfp-title">Some caption</div>' +
        "</div>",
    },
    callbacks: {
      markupParse: function (template, values, item) {
        values.title = item.el.attr("title");
      },
    },
    removalDelay: 300,
    mainClass: "mfp-fade",
  });

  var $quantity = $('.template_assembly-service-product .product .product-info .product-info__quantity-selector');
  var $buyButtons = $('.template_assembly-service-product .product .product-info .product-info__buy-buttons');
  if ($quantity.length && $buyButtons.length) {
    $buyButtons.prepend($quantity);
  }

});


// $(".product-info .product-info__inventory").appendTo(".product-info__inventory + .product-info__variant-picker .variant-picker__option:first-child .h-stack");

// function checkAndSetAvailability(GPO_Data, intervalId) {
//   if ($(GPO_Data).length === 0) {
//     return;
//   }

//   clearInterval(intervalId);
//   $(".gpo-form__group .gpo-label").append('<span class="availability" style="display:none;"></span>');
//   $('<p class="eta_msg" style="display:none;"></p>').insertAfter(".gpo-form__group .gpo-label");

//   $('.gpo-swatches.image-swatches').each(function () {
//     const $input = $(this).find("input");
//     const productHandle = $input.attr("gpo-data-product-handle");
//     const productVarId = $input.attr("gpo-data-variant-id");

//     if (productHandle !== "" && productHandle !== undefined) {
//       getProductAvailability(productHandle, productVarId);
//     }
//   });
// }

// let productPageGPO = '';
// // Product Page GPO
// if ($(".shopify-section--main-product").length !== 0) {
//   productPageGPO = ".product .gpo-swatches.image-swatches";
// }

// if (productPageGPO !== "") {
//   let findGPO = setInterval(function () {
//     checkAndSetAvailability(productPageGPO, findGPO);
//   }, 100);

//   setTimeout(function () {
//     clearInterval(findGPO);
//   }, 50000);
// }

// // Cart Page GPO
// if ($(".shopify-section--main-cart").length) {

//   let GPOAddClass = setInterval(function () {
//     if ($(".cart .gpo-editCart").length) {
//       clearInterval(GPOAddClass);
//       $(".cart .gpo-editCart").addClass("gpoEditBTN");
//       $(".cart .gpo-editCart.gpoEditBTN").click(function () {
//         var checkinputs = setInterval(function () {
//           productPageGPO = ".gpo-cartPopup .gpo-swatches.image-swatches";
//           if ($(productPageGPO).length) {
//             $('.gpo-popupBox').addClass('gpo-loading');
//             let findGPOData = setInterval(function () {
//               checkAndSetAvailability(productPageGPO, findGPOData);
//             }, 100);

//             setTimeout(function () {
//               clearInterval(findGPOData);
//             }, 50000);

//             var checkAttrLength = setInterval(function () {
//               let dataAvailable = $(productPageGPO).find("[data-available]").length;
//               let dataProductHandle = $(productPageGPO).find("[gpo-data-product-handle]").length;
//               if (dataAvailable !== 0 && dataProductHandle !== 0 && dataAvailable === dataProductHandle) {
//                 $(".gpo-cartPopup .gpo-swatches.image-swatches input:checked").trigger("click").trigger("click");
//                 $('.gpo-popupBox').removeClass('gpo-loading');
//                 clearInterval(checkAttrLength);
//               }
//             }, 1000);

//             setTimeout(function () {
//               clearInterval(checkAttrLength);
//             }, 30000);

//             clearInterval(checkinputs);

//           }
//         }, 100);
//       });
//     }
//   }, 100);

//   setTimeout(function () {
//     clearInterval(GPOAddClass);
//   }, 10000);
// }

// function getProductAvailability(p_Handle, p_variant) {
//   const product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data` : `${location.origin}/products/${p_Handle}?view=product_availability_data`;
//   $.ajax({
//     url: product_url,
//     type: "GET",
//     success: function (data) {
//       $("body").append(`<div class="apiData hidden"></div>`);
//       const decodedData = data;
//       $( data ).appendTo( ".apiData" );
//       const Product_Availability = $(".apiData .Product_Availability .product_qty").data("productqty");
//       const Product_restock = $(".apiData .product-info__inventory span.active_variant").data("warning");
//       const Product_eta = $(".apiData .hc-eta.active_variant").text().trim().toLowerCase();
//       const $productElement = $(`[gpo-data-product-handle=${p_Handle}]`);
//       $productElement.attr('data-available', Product_Availability > 0);
//       $productElement.attr('data-restock', Product_restock == 'Pending restock' ? true : false);
//       $productElement.attr('data-eta', Product_eta);
//       $("body .apiData").remove();
//     },
//     error: function (error) {
//       // Log an error message if the AJAX request fails
//       console.error("Error fetching product information:", error);
//     },
//   });
// }

// $(document).on('click', '.gpo-swatches.image-swatches input', function () {
//   const $input = $(this);
//   const productAvailable = $input.data("available");
//   const productRestock = $input.data("restock");
//   const productEta = $input.data("eta");
//   const availabilityDIV = $input.closest(".gpo-form__group").find(".availability");
//   const etaDIV = $input.closest(".gpo-form__group").find(".eta_msg");

//   // restock | available | unavailable
//   if ($input.prop('checked')) {
//     productEta !== "" && productEta !== undefined ? etaDIV.text(productEta).show() : etaDIV.text('').hide();
//     if (productRestock === true) {
//       $input.removeClass('available unavailable').addClass('restock').show();
//       availabilityDIV.text('Pending Restock').removeClass('available unavailable').addClass('restock').show();
//     } else if (productAvailable === true) {
//       $input.removeClass('restock unavailable').addClass('available').show();
//       availabilityDIV.text('In stock').removeClass('restock unavailable').addClass('available').show();
//     } else if (productAvailable === false) {
//       $input.removeClass('restock available').addClass('unavailable').show();
//       availabilityDIV.text('Preorder').removeClass('restock available').addClass('unavailable').show();
//     } else {
//       $input.removeClass('restock available unavailable');
//       availabilityDIV.text('').removeClass('restock available unavailable').hide();
//     }
//   } else {
//     etaDIV.text('').hide();
//     $input.removeClass('restock available unavailable');
//     availabilityDIV.text('').removeClass('restock available unavailable').hide();
//   }
// });


// Script for serch page buy button text issue

$(document).on('click', '.quick-buy-drawer__info .variant-picker__option label', function() {
  setTimeout(function() {
    var p_id = $(".quick-buy-drawer__info input[name='id']").val();
    var text_data = $(`.quick-buy-drawer__info p[data-variant-id="${p_id}"]`).text();
    // console.log("============text_data====================" , text_data)
    $(".quick-buy-drawer__info .buy-buttons .button--lg").text(text_data)
  }, 10); 
});

// $(document).on('click', '.product-card__swatch-list label', function() {
//   setTimeout(function() {
//     var productValue = $('.product-card__swatch-list input:checked').val();
//     var text_data = $(`.product-card__swatch-list p[data-product-card-label-text="${productValue}"]`).text();
//     var element = $(".product-card__swatch-list").closest(".product-card__info").prev(".product-card__figure").find(".product-card__quick-buy button > div").text(text_data)
//     console.log("============element====================" , element)
//   }, 10); 
// });

$(document).on('click', '.product-card__swatch-list label', function() {
    var $swatchList = $(this).closest('.product-card__swatch-list');
    setTimeout(() => {
        var productValue = $swatchList.find('input:checked').val();
        var text_data = $swatchList.find(`p[data-product-card-label-text="${productValue}"]`).text();
        // Ensure you're targeting the correct product card instance
        var element = $swatchList.closest(".product-card__info")
            .prev(".product-card__figure")
            .find(".product-card__quick-buy button > div")
            .text(text_data);
        console.log("============element====================", element);
    }, 10); 
});

//recently view products 
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes("/products/")) {
    // Get the current product handle
    var product_url = window.location.pathname;
    var parts = product_url.split("/");
    var product_handle = parts[parts.length - 1];
  
    // Get existing viewed products from localStorage
    var recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    // Remove the current product if it's already in the array
    recentlyViewedProducts = recentlyViewedProducts.filter(handle => handle !== product_handle);

    // Add the current product to the front of the array
    recentlyViewedProducts.unshift(product_handle);

    // Limit the number of stored products (e.g., 5)
    recentlyViewedProducts = recentlyViewedProducts.slice(0, 5);

    // Save back to localStorage
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProducts));

    if(recentlyViewedProducts.length > 1){
      $('.recently_viewed_product .product-list').empty();
      $('.recent_heading').show();
      $('.popular_heading').hide();
    }
    // Fetch product details and render them
    recentlyViewedProducts.forEach(function(productId) {
      fetch(`/products/${productId}.js`)
        .then(response => response.json())
        .then(product => {
          if (product.handle === product_handle) {
            return; // Skip this product
          }
          var product_url = `${location.origin}/products/${product.handle}?view=recently_view_product` 
          // console.log("Call recently view product_url == ", product_url);
          $.ajax({
            url: product_url,
            type: "GET",
            success: function (data) {
              $(data).appendTo(".recently_viewed_product .product-list");
            },
            error: function (error) {
              // Log an error message if the AJAX request fails
              console.error("Error fetching product information:", error);
            },
          });
        })
        .catch(error => console.error('Error fetching product data:', error));
    });
  }
});

// New Upsell design JS start

let productPageGPO = '';
if ($(".shopify-section--main-product").length !== 0) {
  productPageGPO = ".product-info .gpo-swatches.image-swatches";
}
if (productPageGPO !== "") {
  let findGPO = setInterval(function () {
    changeStructure(productPageGPO, findGPO);
  }, 100);
  setTimeout(function () {
    clearInterval(findGPO);
  }, 50000);
}
function changeStructure(GPO_Data, intervalId){
  if ($(GPO_Data).length === 0) {
    return;
  }
  clearInterval(intervalId);
  let product_id = $('input[name="product-id"]').val();
  if(product_id == 14641416536430 || product_id == 14631786611054 || product_id == 14631784776046 || product_id == 14819825713518){
     var add_upsell_option = $('.gpo-app .wheel_mount .gpo-ov-wrapper');
    if (add_upsell_option.length) {
        add_upsell_option.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/TR_ONE_BASE.jpg?v=1735903226" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">TR ONE BASE FITS FANATEC DD</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 8152736235684 || product_id == 14738576834926 || product_id == 14676768915822 || product_id == 14728626438510 || product_id == 14727193067886 || product_id == 14729137586542 || product_id == 14729138536814 || product_id == 14729138569582 || product_id == 14729138635118){
     var add_upsell_option_trx = $('.gpo-app .custom-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/PHOTO-2025-01-29-00-45-12_1.jpg?v=1738555987" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">FANATEC DD Side Mount</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 14728626438510 ){
     var add_upsell_option_Simulator = $('.gpo-app .gold-custom-trx .gpo-ov-wrapper');
    if (add_upsell_option_Simulator.length) {
        add_upsell_option_Simulator.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/Gold_Seat.jpg?v=1748510509" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Gold Seat</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

   if(product_id == 14631706624366 || product_id == 14631706689902){
     var add_upsell_option_trx = $('.gpo-app .custom-wheelmount-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/TR80-NWMA-WM4_1.png?v=1752036769" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Universal Wheel Deck</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 14751792890222 || product_id == 14818734899566){
     var add_upsell_option_trx = $('.gpo-app .custom-wheelmount-trx .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/TR80-WMPLATE.png?v=1752120379" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">Universal Wheel Deck</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }

  if(product_id == 14818781397358 || product_id == 14819840065902 || product_id == 14890350510446 || product_id == 14824567046510){
     var add_upsell_option_trx = $('.gpo-app .wheel_mount_image .gpo-ov-wrapper');
    if (add_upsell_option_trx.length) {
        add_upsell_option_trx.prepend('<div class="gpo-swatches gpo-ov-item custom_option"><label><img src="https://cdn.shopify.com/s/files/1/0601/1312/5540/files/TR_ONE_BASE_412087f1-f2df-46ff-bd55-3ead2442bbfc.jpg?v=1759924848" /></label><div class="upsell_all_detail"><div class="included_tag">INCLUDED</div><div class="upsell_detail"><div class="upsell_name">FANATEC DD SIDE MOUNT</div></div></div></div>');
    } else {
        console.log('Target element not found');
    }
  }
  
  let upsell = $('.gpo-swatches.image-swatches.gpo-ov-item');
  $('.gpo-app .gpo-swatches input').show();
  $('.gpo-app .gpo-swatches .gpo-ov-extend').remove();
  for(let i=0;i<upsell.length;i++)
  {
    let upsell_name = $( upsell[i] ).find('.gpo-tooltip.zoom-image .gpo-tooltip__title span:first-child').text();
    let upsell_price = $( upsell[i] ).find('.gpo-tooltip.zoom-image .gpo-tooltip__title span.addOn').text().replace(/[()+]/g, '');
    if(upsell_price != ""){
      upsell_price = upsell_price.trim();
    }
    let upsell_image_span = $(upsell[i]).find('.gpo-swatch__inner .swatch-image');
    var backgroundImage = $(upsell_image_span).attr('src');
    // var backgroundImage_src = '';
    // if(backgroundImage){
    //  backgroundImage_src = backgroundImage.split('?')[0];
    //   backgroundImage_src.pop();
    // }
    var image_new = $(upsell[i]).find('.gpo-swatch__inner');
    if (backgroundImage) {
      let backgroundImage_src = backgroundImage.split('?')[0];
      image_new.append(`<div class="upsell_image_div"><img src="${backgroundImage_src}" alt="Upsell Image"></div>`);
    } else {
      // Fallback image if no src found
        image_new.append(`<div class="upsell_image_div"><img src="${backgroundImage}" alt="Upsell Image"></div>`);
    }
    // image_new.append(`<div class="upsell_image_div"><img src="${ backgroundImage_src }"></div>`);
    $( upsell[i] ).append(`<div class="upsell_detail"><div class="upsell_price">${upsell_price}</div><div class="upsell_name">${upsell_name}</div></div>`); 
    $(upsell_image_span).css('background', 'none');
    $(upsell[i]).append('<div class="upsell_all_detail"></div>');
    let find_input = $( upsell[i] ).find('input');
    let find_selected_input = $( upsell[i] ).find('input:checked');
    let upsell_div = $( upsell[i] ).find('.upsell_all_detail');
    let upsell_detail = $( upsell[i] ).find('.upsell_detail');
    upsell_div.append(find_input);
    upsell_div.append(upsell_detail);
    $(find_selected_input).closest('.upsell_all_detail').addClass('has-checked');
    const $input = $(upsell[i]).find("input");
    const productHandle = $input.attr("gpo-data-product-handle");
    const productVarId = $input.attr("gpo-data-variant-id");
    let tooltip_product = false;
    if (productVarId == 41766497550500) {
      tooltip_product = true;
    }
    if (tooltip_product) {
      $(upsell[i]).append(`<div class="stock_main"><span class="upsell_stock" data-handle="${productHandle}"></span></div>
        <div class="upsell_tooltip">
          <span class="tooltip_massage">only compatible with the pre-drilled plate</span>
          <img class="tooltip_info_icon" alt="INFO" src="https://cdn.shopify.com/s/files/1/0268/8149/1135/files/info.png?v=1750231628">
        </div>
        `);    
    } else {
      $(upsell[i]).append(`<div class="stock_main"><span class="upsell_stock" data-handle="${productHandle}"></span></div>`);
    }
    $(upsell[i]).append(`<div class="test_box" id="test_box_${productHandle}"></div>`);
    if (productHandle !== "" && productHandle !== undefined) {
      getProductAvailability(productHandle, productVarId);
      var view_product_url = productVarId !== "" ? `${location.origin}/products/${productHandle}?variant=${productVarId}` : `${location.origin}/products/${productHandle}`;
      $(upsell[i]).find('label').append(`<a href="${ view_product_url }" name="product_info_link" class="product_info_link" target="_blank">View Info</a>`);
      
      const link = upsell[i].querySelector('.product_info_link');
      const testBox = upsell[i].querySelector('.test_box');
      
      // Stop click event from propagating when the link is clicked
      link.addEventListener('click', function(event) {
          event.stopPropagation(); // Prevent the click event from bubbling up
      });
      // Add a click event listener for the test box
      testBox.addEventListener('click', function() {
          console.log('Test box clicked!');
          // Additional actions for the test box can be placed here
      });
    }
  }
  $(document).on("click", ".upsell_tooltip", function () {
    $(this).toggleClass("active");
  });
  
  var options_groups = $('.gpo-app .gpo-element');
  for(let j=0;j<options_groups.length;j++){
   
    var checked_value = $( options_groups[j] ).find('.gpo-swatches.image-swatches.gpo-ov-item .upsell_all_detail.has-checked');
    if(checked_value.length > 0){
     let total_amount = $( options_groups[j] ).find('.gpo-label .addOn');
      if(total_amount.length == 0){
        let disble_options = $( options_groups[j] ).find('.gpo-swatches.image-swatches.gpo-ov-item');
        
      }
    }
  }
  
  var options_groups = $('.gpo-app .none_selection .gpo-ov-wrapper');
  for(let i=0;i<options_groups.length;i++){
    var options = $(options_groups[i]).find('.gpo-swatches.image-swatches.gpo-ov-item');
    for(let j=0;j<options.length;j++){
      $(options[j]).attr('data-custom-index', j);
    }
  }
  $(document).on("click", ".gpo-app .none_selection .gpo-ov-wrapper .test_box", function () {
    var current_parent = $(this).closest('.gpo-form__group');
    var data_index = $(this).closest('.gpo-swatches').data('custom-index');
    if(data_index > 0){
      // $(".none_select_alert" ).remove();
      // $(".none_select_alert").empty();
      var data_index_0 =$(current_parent).find('.gpo-swatches[data-custom-index=0]'); 
      var check_class = $(data_index_0).find('.upsell_all_detail.has-checked');
      if(check_class.length > 0){
        $(data_index_0).find("label").click();
        $(current_parent).find('.gpo-swatches[data-custom-index=0]').find('.upsell_all_detail.has-checked').removeClass('has-checked');
      }
    }
    if(data_index == 0){
      // $(".none_select_alert" ).remove();
      // $(".none_select_alert").empty();
      // $(current_parent).find('.gpo-label').append('<span class="none_select_alert">All upsell selections will be cleared if you select none.</span>');
      var data_index_all =$(current_parent).find('.gpo-swatches[data-custom-index!=0] .upsell_all_detail.has-checked'); 
      $(data_index_all).siblings("label").click();
      // $(".none_select_alert").delay(1000).fadeOut(3000);
    }
  });
  
  // Upsell Slider initialization
  $('.product-info .gpo-element .gpo-ov-wrapper').slick({
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4.5,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
        }
      },
     {
        breakpoint: 999,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        }
      }
    ]
  });
  
}
function getProductAvailability(p_Handle, p_variant) {
  var product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data_upsell` : `${location.origin}/products/${p_Handle}?view=product_availability_data_upsell`;
  // console.log("product_url == ", product_url);
  var only_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}` : `${location.origin}/products/${p_Handle}`;
  $.ajax({
    url: product_url,
    type: "GET",
    success: function (data) {
      $("body").append(`<div class="apiData hide"></div>`);
      $(data).appendTo(".apiData");
      var Product_Availability = "", Product_restock = "", Product_eta = "", $productElement = $(`[gpo-data-product-handle=${p_Handle}]`), Product_link = $(".apiData .Product_link").text();
      Product_restock = $(".apiData .product-info__inventory span").data("stock");
      if(Product_restock == 'In-Stock'){
        $(`span[data-handle="${p_Handle}"]`).addClass('instock').text(Product_restock);
      } else if(Product_restock == 'Pre-Order') {
        $(`span[data-handle="${p_Handle}"]`).addClass('preorder').text(Product_restock);
      } else {
        $(`span[data-handle="${p_Handle}"]`).addClass('outofstock').text(Product_restock);
      }

      if(Product_restock == 'Sold Out'){
        $('#test_box_' + p_Handle).addClass("sold_out");
        $('#test_box_' + p_Handle).closest('.gpo-swatches.image-swatches').addClass("sold_out_main_div");
      }
      $("body .apiData").remove();
    },
    error: function (error) {
      // Log an error message if the AJAX request fails
      console.error("Error fetching product information:", error);
      var url = $(`[href="${ only_url }"]`);
      $(url).hide();
      console.log("url" , url)
      $(`#test_box_${p_Handle}`).closest('.gpo-swatches').css('pointer-events','none');
      document.getElementById(`test_box_${p_Handle}`).disabled = true;
    },
  });
}
$(document).on("click",".gpo-swatches label",function() {
  let find_selected_input = $(this).closest('.gpo-swatches').find('input');
  var checkHasClass = $(find_selected_input).closest('.upsell_all_detail').hasClass('has-checked');
  var checkHasClass = $(find_selected_input).closest('.gpo-swatches').find('label .product_info_link').hasClass('has-checked-button');
  let input_type = find_selected_input.attr('type');
  if(input_type == "radio"){
    $(this).closest('.gpo-ov-wrapper').find( ".upsell_all_detail" ).removeClass( "has-checked" );
  }
  if(checkHasClass){
    $(find_selected_input).closest('.upsell_all_detail').removeClass('has-checked');
    $(find_selected_input).closest('.gpo-swatches').find('label .product_info_link').removeClass('has-checked-button');
  } else {
    $(find_selected_input).closest('.upsell_all_detail').addClass('has-checked');
    $(find_selected_input).closest('.gpo-swatches').find('label .product_info_link').addClass('has-checked-button');
  }
});

$(document).on("click", ".gpo-swatches .test_box", function () {
  $(this).closest('.gpo-swatches').find("label").click();
});

// New Upsell design JS end


// ================ GPO Cart Page ================ //
let cart_PageGPO = "";
if ($("body.template_cart .order-summary .order-summary__body").length !== 0) {
  cart_PageGPO = "button.gpo-editCart";
}

if (cart_PageGPO !== "") {
  let findGPO = setInterval(function () {
    cart_add_event(cart_PageGPO, findGPO);
  }, 100);
  setTimeout(function () {
    clearInterval(findGPO);
  }, 50000);
}

function cart_add_event(GPO_Data, intervalId) {
  if ($(GPO_Data).length === 0) {
    return;
  }
  clearInterval(intervalId);
  // console.log("Cart Page Option button GET ==================");

  $(document).on("click", "button.gpo-editCart", function () {
    // console.log("============= Click On the GPO-Edit-Cart =============");
  });

  $(document).on("click", ".gpo-cartPopup .gpo-app .none_selection .gpo-ov-wrapper label", function () {
    // console.log("============= Click On the Cart Label =============");
    var current_parent = $(this).closest(".gpo-form__group");
    var this_swatch = $(this).closest(".gpo-swatches");
    var is_this_first_child = this_swatch.is(this_swatch.parent().children(".gpo-swatches").first());

    if (is_this_first_child) {
      // console.log("=====> This label is in the FIRST swatch group.");
      var data_index_all = current_parent.find(".gpo-swatches:not(:first-child) input:checked");
      $(data_index_all).siblings("label").click();
    } else {
      // console.log("=====> This label is NOT in the first swatch group.");
      var first_swatch_label = current_parent.find(".gpo-swatches:first-child label").first();
      var first_swatch_input = current_parent.find(".gpo-swatches:first-child input").first();

      if (first_swatch_input.is(":checked")) {
        // console.log("First child is checked.");
        first_swatch_label.click();
      }
    }
  });
}
// ================ GPO Cart Page END ================ //


$(".black_friday_offer_close").click(function(){
  $(".black_friday_offer").hide();
});

// gift card page js
$(document).ready( function () {
  $('<div id = "newElement" class="qty_cart_btn"></div>').insertBefore($('.product-info .buy-buttons'));
  // $("body").append('<div id = "newElement" class="qty_cart_btn"></div>');
  $('.template_custom-gift-temp .product-info .quantity-selector').appendTo('.qty_cart_btn');
  $('.template_custom-gift-temp .product-info .buy-buttons').appendTo('.qty_cart_btn');
  $(".template_custom-gift-temp .gift-card-recipient__fields input").removeAttr("required");
  var checkbox_value = $(".template_custom-gift-temp .checkbox-container").find("input[type='checkbox']").is(':checked');
  if(checkbox_value == "true"){
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '1');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'all');
  }
    $('.template_custom-gift-temp .gift-slideshow-wrapper').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
  });
});

$('.template_custom-gift-temp .checkbox-container .checkbox').click(function(){
  var checkbox_value = $(this).is(':checked');
  console.log("***********checkbox_value***************" , checkbox_value)
  if(checkbox_value){
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '1');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'all');
    $(".template_custom-gift-temp .gift-card-recipient__fields input").attr("required", "true");
    $(".template_custom-gift-temp .gift-card-recipient__fields input[type='date']").removeAttr("required");
  } else {
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('opacity', '0.3');
    $(".template_custom-gift-temp .gift-card-recipient__fields").css('pointer-events', 'none');
  }
});


$('.template_custom-gift-temp .variant-wrapper-image .variant__button-label').click(function(){
  $('.template_custom-gift-temp .input_label').removeClass('active');
  console.log("click event")
  $(this).find('.input_label').addClass('active');
});

// New Header & footer Design JS Start
function set_default_menu() {
  var menu_li = $(".mega-menu");
  $(menu_li).each(function () {
    var menu_image = $(this).find(".collection_image_menu");
    $(menu_image[0]).addClass("first_menu")
    var menu_image_url = $(menu_image).data("menu-image");
    var decodedUrl = decodeURIComponent(menu_image_url);
    var menu_image_div = $(menu_image).parents("li.v-stack").closest("ul.mega-menu__nav").find(".menu_image_div");
    $(menu_image_div).empty();
    var e = `<img src="${decodedUrl}" alt="Menu Image">`;
    $(menu_image_div).append(e);
  });
}

$(document).ready(function () {
  $("li.image_menu_li").parent().siblings("a").css("padding-left", "16px");
  if ($('.menu_image_div').is(':empty')) {
  }
});

$(document).on("mouseover", ".collection_image_menu", function () {
  var menu_image = $(this).data("menu-image");
  $(this).removeClass("first_menu")
  var decodedUrl = decodeURIComponent(menu_image);
  var menu_image_div = $(this).parents("li.v-stack").closest("ul.mega-menu__nav").find(".menu_image_div");
  $(menu_image_div).empty();
  var e = `<img src="${decodedUrl}" alt="Menu Image">`;
  $(menu_image_div).append(e);
});

$(document).on("mouseleave", ".collection_image_menu", function () {
  var menu_image_div = $(this).parents("li.v-stack").closest("ul.mega-menu__nav").find(".menu_image_div");
  $(menu_image_div).empty();
});

var country_div = $('.template_index .shopify-section--featured-collection .country_section');
$(".template_index .shopify-section--featured-collection .country_view_all").prepend(country_div);

$(document).on("click", ".mobile_navigation_first_li", function () {
  var data_id = $(this).data('id');
  console.log("data_id", data_id)
  var $dataDiv = $(`.panel.gap-8 #${data_id}`);
  console.log("data_div:", $dataDiv);
  
  $('.mobile_navigation_grand_child_ul .grand_li').removeClass('active');
  
  //rama already-active
  $('.mobile_navigation_grand_child_ul .grand_li.already-active').addClass('active');

  $(`.panel.gap-8 .panel__wrapper:not(#${data_id})`).attr('hidden', true);

  setTimeout(function () {
    $dataDiv.removeAttr('hidden');
    $('.mobile_navigation_grand_child_ul .panel .panel__wrapper').removeAttr('hidden');
    $('.mobile_navigation_grand_child_ul .panel .panel__wrapper:not(.active-block-wrapper)').css("display", "none");
  }, 300);
});

$(document).on("click", ".grand_li", function () {
  $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
  $(this).find('.panel .panel__wrapper').slideToggle();
  $(this).find('.panel').css({
    "visibility": "visible",
    "opacity": "1",
    "display": "block"
  });
});

// active-panel in mobile view menu
$(document).ready(function () {
  const $activePanels = $('.panel.active-panel');
  if ($activePanels.length) {
    const observer = new MutationObserver(function () {
      $activePanels.each(function () {
        if ($(this).css('visibility') === 'hidden' || $(this).css('opacity') == '0') {
          $(this).css({
              opacity: '1',
              visibility: 'visible',
              display: 'block'
          });
        }
      });
    });

    $activePanels.each(function () {
      observer.observe(this, {
        attributes: true,
        attributeFilter: ['style']
      });
    });
  }
});

// New Header & footer Design JS end

 // $(document).ready(function () {
 //    $('.tab').on('click', function () {
 //      // Toggle active class between buttons
 //      $('.tab').removeClass('active');
 //      $(this).addClass('active');
 //      var id = $(this).attr('id');
 //      if (id == 'tab1') {
 //        console.log("$('#video1'):: ", $('#video1'));
 //        $('.video-1').addClass('active');
 //        $('.video-2').removeClass('active');
 //      } else if (id == 'tab2') {
 //        console.log("$('#video2'):: ", $('#video2'));
 //        $('.video-2').addClass('active');
 //        $('.video-1').removeClass('active');
 //      }
 //    });
 //  });

$(document).ready(function () {
    $('.tab').on('click', function () {
      // Toggle active class between tabs
      $('.tab').removeClass('active');
      $(this).addClass('active');

      var id = $(this).attr('id');
      $('.blue-rig-container .default-image').css('display','none');

      if (id === 'tab1') {
        // Show video1, hide video2
        $('.video-1').show().addClass('active')[0].play();
        $('.video-2')[0].pause();
        $('.video-2').hide().removeClass('active');
      } else if (id === 'tab2') {
        // Show video2, hide video1
        $('.video-2').show().addClass('active')[0].play();
        $('.video-1')[0].pause();
        $('.video-1').hide().removeClass('active');
      }
    });
  });
$(document).ready(function(){
  $('.video-slideshow-section .video-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 5000,
  });
});

$(document).ready(function () {
  const $querySelect = $('.options-select');

  $querySelect.on('change', function () {
    const selectedValue = $(this).val();
    const $parent = $(this).closest('.form-control-opetion');

    // Set custom attribute
    $parent.attr('optionvalue', selectedValue);

    // Remove any existing budget block
    $parent.find('.select-label-text-main').remove();

    // Add budget dropdown if "Sales inquiry" is selected
    if (selectedValue === 'Sales inquiry') {
      const budgetHTML = `
        <div class="select-label-text-main">
          <div class="select-label-text">Budget</div>
          <div class="form-control-select budget">
            <select class="select select--native is-floating" name="contact[Budget]" required>
              <option value="Unsure">Unsure</option>
              <option value="$0 - $1000">$0 - $1000</option>
              <option value="$1000 - $2500">$1000 - $2500</option>
              <option value="$2500 - $5000">$2500 - $5000</option>
              <option value="$5000 - $10000">$5000 - $10000</option>
              <option value="$10000+">$10000+</option>
            </select>
            <div class="custom-contact-form-select-icon">
              <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.5L4 4.5L7 1.5" stroke="#121212" stroke-width="2"></path>
              </svg>
            </div>
          </div>
        </div>
      `;
      $parent.find('.form-control-opetions').append(budgetHTML);
    }

    // Clear and handle message for "Order tracking/adjustment"
    const $messageContainer = $parent.find('.form-control-select-order');
    $messageContainer.empty();

    if (selectedValue === 'Order tracking/adjustment' || selectedValue === 'Order problem') {
      const messageText = `Please refrain from submitting multiple tickets for the same issue, as this can further delay our response time.`;
      const inputHTML = `
        <textarea readonly rows="3" name="contact[order]" style="width: 100%;">${messageText}</textarea>
      `;
      $messageContainer.append(inputHTML);
    }
  });
});

$(document).ready(function () {
  // Instant check on page load (normal form submission)
    console.log('Scrolled to top after success message (page)');
  if ($('.banner.banner--success').length > 0) {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    console.log('Scrolled to top after success message (page load)');
  }

  // Interval check for dynamically added success message (AJAX)
  var checkNote = setInterval(function () {
    if ($('.banner.banner--success').length > 0) {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      console.log('Scrolled to top after success message (AJAX)');
      clearInterval(checkNote);
    }
  }, 1000);

  // Optional: stop checking after 5 seconds
  setTimeout(function () {
    clearInterval(checkNote);
  }, 5000);
});

$(document).ready(function () {
    $(document).on('click', '.metafield-rich_text_field ul li', function () {
    if ($(this).has('strong').length) {
      $(this).toggleClass('active');
    }
  });
  
   $(document).on('click', '.accordion-content-v2.accordion-content-features .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-features .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });
  
  $(document).on('click', '.accordion-content-v2.accordion-content-compatibility .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-compatibility .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  $(document).on('click', '.accordion-content-v2.accordion-content-included .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-included .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  
  $(document).on('click', '.specification-table .specifications-tabel-content .accordion-read-more', function () {
    $('.specification-table .specifications-tabel-content .metafield-rich_text_field ul').css('display','grid');
    $(this).hide(); // Hide the button after click
  });
  
});


$(document).ready(function () {
  // Function to initialize the mobile slider
  function initMobileSlider() {
    var $slider = $('.contentbox-container');
    var $progressBar = $('.progress-bar');
    var $progressLabel = $('.progress-label');

    // Run only if screen width ≤ 575px
    if ($(window).width() <= 575) {
      // Initialize slick only once
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
          speed: 600,
          appendArrows: $('.content-box3-arrow'),
          adaptiveHeight: false,
           prevArrow: `
            <button type="button" class="slick-prev" aria-label="Previous">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
                <path d="M14.9141 27.1804L1.41406 14.6804L14.4141 0.68042" stroke="#959595" stroke-width="2"/>
              </svg>
            </button>
          `,
          nextArrow: `
            <button type="button" class="slick-next" aria-label="Next">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
                <path d="M0.679199 0.733765L14.1792 13.2338L1.1792 27.2338" stroke="#959595" stroke-width="2"/>
              </svg>
            </button>
          `
        });

        // Progress update on slide change
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var calc = (nextSlide / (slick.slideCount - 1)) * 100;
          $progressBar.css('width', calc + '%').attr('aria-valuenow', calc);
          $progressLabel.text(Math.round(calc) + '% completed');
        });

        // Initial setup (first slide)
        $progressBar.css('width', '0%');
        $progressLabel.text('0% completed');
      }
    } else {
      // Destroy slick when window width > 575px
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
        $progressBar.css('width', '0%');
        $progressLabel.text('');
      }
    }
  }

  // Initialize on load
  initMobileSlider();

  // Recheck on resize
  $(window).on('resize', function () {
    initMobileSlider();
  });
});


//Reseller page complete script start
$(document).ready(function () {
  // Next button click
  $('.contact-button-next').click(function (event) {
    event.preventDefault();

    var currentSection = $(this).closest('.custom-contact-form-tab-filed-input');
    var nextSection = currentSection.next('.custom-contact-form-tab-filed-input');

    // -------------------------------
    // Validation
    // -------------------------------
    var inputs = currentSection.find('.required');
    var isValid = true;

    inputs.each(function () {

      let errorEl = this.nextElementSibling;
      
      if ($(this).attr('type') === 'checkbox') {
        
        let parentElem = this.closest('.checkbox-field');
        errorEl = parentElem.querySelector('.empty-error-message');
        let checkboxes = parentElem.querySelectorAll('input[type="checkbox"]');

        checkboxes.forEach((cb) => {
          cb.addEventListener('change', function () {
            let anyChecked = Array.from(checkboxes).some((c) => c.checked);
            if (anyChecked) {
              checkboxes.forEach((c) => c.classList.remove('required'));
              if (errorEl && errorEl.classList.contains('empty-error-message')) {
                  errorEl.classList.remove('active_error');
              }
            }
            else 
            {
              checkboxes.forEach((c) => c.classList.add('required'));
            }
          });
        });

        let anyChecked1 = Array.from(checkboxes).some((c) => c.checked);
        if(!anyChecked1){
          this.focus();
          isValid = false;
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.add('active_error');
          }
          return false;
        }

      } else if ($(this).attr('type') === 'radio') {
        
        let parentElem = this.closest('.radio-field');
        errorEl = parentElem.querySelector('.empty-error-message');
        let radios = document.querySelectorAll('input[type="radio"]');

        radios.forEach((rb) => {
          rb.addEventListener('change', function () {
            let anyChecked = Array.from(radios).some((c) => c.checked);
            if (anyChecked) {
              radios.forEach((c) => c.classList.remove('required'));
              if (errorEl && errorEl.classList.contains('empty-error-message')) {
                  errorEl.classList.remove('active_error');
              }
            }
            else 
            {
              radios.forEach((c) => c.classList.add('required'));
            }
          });
        });

        let anyChecked1 = Array.from(radios).some((c) => c.checked);
        if(!anyChecked1){
          this.focus();
          isValid = false;
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.add('active_error');
          }
          return false;
        }
        
      } //else closed

      $(this).off("input change").on("input change", function () {
        if (errorEl && errorEl.classList.contains('empty-error-message')) {
            errorEl.classList.remove('active_error');
        }
        $(this).removeClass('error');
      });

      if (!this.value.trim()) {
        this.focus();
        isValid = false;

        if (errorEl && errorEl.classList.contains('empty-error-message')) {
          errorEl.classList.add('active_error');
        }

        if ($(this).attr('type') !== 'checkbox' && $(this).attr('type') !== 'radio') {
            $(this).addClass('error');
        }
        return false; // break each loop
      } 
      else 
      {
        if(isValid)
        {
          if (errorEl && errorEl.classList.contains('empty-error-message')) {
              errorEl.classList.remove('active_error');
          }
          $(this).removeClass('error');
        }
      } // else closed
      
    });

    if (!isValid) return;

    // -------------------------------
    // Switch to next step
    // -------------------------------
    if (nextSection.length) {
      currentSection.removeClass('active');
      nextSection.addClass('active');

      var index = $('.custom-contact-form-tab-filed-input').index(nextSection);

      // Update tab numbers
      if ($('.custom-contact-form-tab-number-main.desktop').is(':visible')) {
        $('.custom-contact-form-tab-number-main.desktop .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');
      } else {
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-number-text .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');

        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab .custom-contact-form-tab-number-text')
            .removeClass('active')
            .eq(index)
            .addClass('active');
      }

      // -------------------------------
      // Scroll to next tab & focus first input
      // -------------------------------
      let firstInput = nextSection.find('input, select, textarea').first();
      let specific_div = $("#custom-contact-form");

      if (firstInput.length) {
        $('html, body').animate({
            scrollTop: nextSection.offset().top - 50
        }, 100, function () {
            firstInput.focus();
        });
      }
      else
      {
        $('html, body').animate({
            scrollTop: specific_div.offset().top - 50
        }, 100);
      }
    } // outer if closed

    $('.custom-contect-main.active').removeClass('active');
  });

  // Back button click
  $('.contact-button-back').click(function () {
    var currentSection = $(this).closest('.custom-contact-form-tab-filed-input');
    var prevSection = currentSection.prev('.custom-contact-form-tab-filed-input');

    if (prevSection.length) {
      currentSection.removeClass('active');
      prevSection.addClass('active');

      var index = $('.custom-contact-form-tab-filed-input').index(prevSection);

      if ($('.custom-contact-form-tab-number-main.desktop').is(':visible')) {
        // Desktop
        $('.custom-contact-form-tab-number-main.desktop .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');

          
        // Get the text of the currently active tab
        var tabText = $('.custom-contact-form-tab-number-text.active').find('.custom-contact-form-tab-text').first().text().trim();
        // Example: do something based on active tab
        if (tabText === 'Company Information') {
            $('.custom-contect-main').addClass('active');
        }

      } else {
        // Mobile
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-number-text .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');
        $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab .custom-contact-form-tab-number-text').removeClass('active').eq(index).addClass('active');
          // Get the text of the currently active tab
         var tabText = $('.custom-contact-form-tab-number-main.mobile .custom-contact-form-tab-number-text.active').find('.custom-contact-form-tab-text').first().text().trim();
          // Example: do something based on active tab
          if (tabText === 'Company Information') {
              $('.custom-contect-main').addClass('active');
          }
      }

      let prevFirstInput = prevSection.find('input, select, textarea').first();
      let specific_div = $("#custom-contact-form");

      if (prevFirstInput.length) {
        $('html, body').animate({
            scrollTop: prevSection.offset().top - 50
        }, 100, function () {
            prevFirstInput.focus();
        });
      }
      else
      {
        $('html, body').animate({
            scrollTop: specific_div.offset().top - 50
        }, 100);
      }

    }// if closed
  });

  // Add new input dynamically
  $(document).on('click', '.contact-input-add-text', function (e) {
    e.preventDefault();

    $(".contact-input-add").append(
      `<div class="contact-required">
        <input
          type="text"
          class="input-full required"
          name="contact[company_website]"
          placeholder="https://"
        >
        <button class="remove-btn" value="Remove">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L20 20" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M4 20L20 4" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>`
    );
  });

  // Remove input
  $(document).on('click', '.remove-btn', function (e) {
    e.preventDefault();
    $(this).closest('.contact-required').remove();
  });

 function hideIntroIfSuccess() {
    if ($('.custom-contact-form-posted-success.active').length) {
      $('.custom-contect-main, .custom-contact-main').removeClass('active');
    }
  }

  // 1. Run once on page load
  hideIntroIfSuccess();

  // 2. Run again when the button is clicked
  $(document).on('click', '.submit-application-button', function() {
    hideIntroIfSuccess();
  });

});
//Reseller page complete script end


// function checkAndSetAvailability(GPO_Data, intervalId) {
//   if ($(GPO_Data).length === 0) {
//     return;
//   }

//   clearInterval(intervalId);
//   $(".gpo-form__group .gpo-label").append('<span class="availability" style="display:none;"></span>');
//   $('<p class="eta_msg" style="display:none;"></p>').insertAfter(".gpo-form__group .gpo-label");

//   $('.gpo-swatches.image-swatches').each(function () {
//     const $input = $(this).find("input");
//     const productHandle = $input.attr("gpo-data-product-handle");
//     const productVarId = $input.attr("gpo-data-variant-id");

//     if (productHandle !== "" && productHandle !== undefined) {
//       getProductAvailability(productHandle, productVarId);
//     }
//   });
// }

// let productPageGPOCart = '';
// // Product Page GPO
// if ($(".shopify-section--main-product").length !== 0) {
//   productPageGPOCart = ".product .gpo-swatches.image-swatches";
// }

// if (productPageGPOCart !== "") {
//   let findGPO = setInterval(function () {
//     checkAndSetAvailability(productPageGPOCart, findGPO);
//   }, 100);

//   setTimeout(function () {
//     clearInterval(findGPO);
//   }, 50000);
// }

// // Cart Page GPO
// if ($(".shopify-section--main-cart").length) {

//   let GPOAddClass = setInterval(function () {
//     if ($(".cart .gpo-editCart").length) {
//       clearInterval(GPOAddClass);
//       $(".cart .gpo-editCart").addClass("gpoEditBTN");
//       $(".cart .gpo-editCart.gpoEditBTN").click(function () {
//         var checkinputs = setInterval(function () {
//           productPageGPOCart = ".gpo-cartPopup .gpo-swatches.image-swatches";
//           if ($(productPageGPOCart).length) {
//             $('.gpo-popupBox').addClass('gpo-loading');
//             let findGPOData = setInterval(function () {
//               checkAndSetAvailability(productPageGPOCart, findGPOData);
//             }, 100);

//             setTimeout(function () {
//               clearInterval(findGPOData);
//             }, 50000);

//             var checkAttrLength = setInterval(function () {
//               let dataAvailable = $(productPageGPOCart).find("[data-available]").length;
//               let dataProductHandle = $(productPageGPOCart).find("[gpo-data-product-handle]").length;
//               if (dataAvailable !== 0 && dataProductHandle !== 0 && dataAvailable === dataProductHandle) {
//                 $(".gpo-cartPopup .gpo-swatches.image-swatches input:checked").trigger("click").trigger("click");
//                 $('.gpo-popupBox').removeClass('gpo-loading');
//                 clearInterval(checkAttrLength);
//               }
//             }, 1000);

//             setTimeout(function () {
//               clearInterval(checkAttrLength);
//             }, 30000);

//             clearInterval(checkinputs);

//           }
//         }, 100);
//       });
//     }
//   }, 100);

//   setTimeout(function () {
//     clearInterval(GPOAddClass);
//   }, 10000);
// }

// function getProductAvailability(p_Handle, p_variant) {
//   const product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data` : `${location.origin}/products/${p_Handle}?view=product_availability_data`;
//   console.log('product_url--', product_url);
//   $.ajax({
//     url: product_url,
//     type: "GET",
//     success: function (data) {
//       $("body").append(`<div class="apiData hidden"></div>`);
//       const decodedData = data;
//       $( data ).appendTo( ".apiData" );
//       const Product_Availability = $(".apiData .Product_Availability .product_qty").data("productqty");
//       const Product_restock = $(".apiData .product-info__inventory span.active_variant").data("warning");
//       const Product_eta = $(".apiData .hc-eta.active_variant").text().trim().toLowerCase();
//       const $productElement = $(`[gpo-data-product-handle=${p_Handle}]`);
//       $productElement.attr('data-available', Product_Availability > 0);
//       $productElement.attr('data-restock', Product_restock == 'Pending restock' ? true : false);
//       $productElement.attr('data-eta', Product_eta);
//       $("body .apiData").remove();
//     },
//     error: function (error) {
//       // Log an error message if the AJAX request fails
//       console.error("Error fetching product information:", error);
//     },
//   });
// }
// cart page edit opetion sold product start
function checkAndSetAvailabilitycart(GPO_Data, intervalId) {
  if ($(GPO_Data).length === 0) {
    return;
  }
  clearInterval(intervalId);
  $(".gpo-form__group .gpo-label").append('<span class="availability" style="display:none;"></span>');
  $('<p class="eta_msg" style="display:none;"></p>').insertAfter(".gpo-form__group .gpo-label");

  $('.gpo-swatches.image-swatches').each(function () {
    const $input = $(this).find("input");
    const productHandle = $input.attr("gpo-data-product-handle");
    const productVarId = $input.attr("gpo-data-variant-id");

    if (productHandle !== "" && productHandle !== undefined) {
      getProductAvailabilityCart(productHandle, productVarId);
    }
  });
}

let productPageGPO_1 = '';
// Product Page GPO
if ($(".shopify-section--main-product").length !== 0) {
  productPageGPO_1 = ".product .gpo-swatches.image-swatches";
}

if (productPageGPO_1 !== "") {
  let findGPO = setInterval(function () {
    checkAndSetAvailabilitycart(productPageGPO_1, findGPO);
  }, 100);

  setTimeout(function () {
    clearInterval(findGPO);
  }, 50000);
}

if ($(".shopify-section--main-cart").length) {

  let GPOAddClass = setInterval(function () {
    if ($(".cart .gpo-editCart").length) {
      clearInterval(GPOAddClass);
      $(".cart .gpo-editCart").addClass("gpoEditBTN");
      $(".cart .gpo-editCart.gpoEditBTN").click(function () {
        var checkinputs = setInterval(function () {
          productPageGPO_1 = ".gpo-cartPopup .gpo-swatches.image-swatches";
          if ($(productPageGPO_1).length) {
            $('.gpo-popupBox').addClass('gpo-loading');
            let findGPOData = setInterval(function () {
              checkAndSetAvailabilitycart(productPageGPO_1, findGPOData);
            }, 100);

            setTimeout(function () {
              clearInterval(findGPOData);
            }, 50000);
            clearInterval(checkinputs);

          }
        }, 100);
      });
    }
  }, 100);
  // function getProductAvailabilityCart(p_Handle, p_variant) {
  // const product_url = p_variant !== "" ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data` : `${location.origin}/products/${p_Handle}?view=product_availability_data`;
  // console.log("product_url == ", product_url);
  // }

function getProductAvailabilityCart(p_Handle, p_variant) {
  var product_url = p_variant !== "" 
    ? `${location.origin}/products/${p_Handle}?variant=${p_variant}&view=product_availability_data_upsell` 
    : `${location.origin}/products/${p_Handle}?view=product_availability_data_upsell`;

  var only_url = p_variant !== "" 
    ? `${location.origin}/products/${p_Handle}?variant=${p_variant}` 
    : `${location.origin}/products/${p_Handle}`;

  console.log("Product URL:", product_url);
  console.log("Only URL:", only_url);

  $.ajax({
    url: product_url,
    type: "GET",
    success: function (data) {
      // Remove any previous apiData container
      $("body .apiData").remove();
      $("body").append(`<div class="apiData hide"></div>`);
      $(data).appendTo(".apiData");

      // Variables
      var Product_Availability = "";
      var Product_restock = "";
      var Product_eta = "";
      var $productElement = $(`[gpo-data-product-handle="${p_Handle}"]`);
      var Product_link = $(".apiData .Product_link").text();
      Product_restock = $(".apiData .product-info__inventory span").data("stock");

      // Log all variables
      console.log("Product Element:", $productElement);
      console.log("Product Link:", Product_link);
      console.log("Product Restock Status:", Product_restock);
      console.log("Product Availability:", Product_Availability);
      console.log("Product ETA:", Product_eta);
      // Append the Product_restock text to each swatch
     $(".gpo-swatches.image-swatches").each(function() {
  const $swatch = $(this);
  const handle = $swatch.find("input").attr("gpo-data-product-handle");

  // Remove previously added availability spans
  $swatch.find(".availability").remove();

  // Check if this swatch's handle matches Product_restock handle
  if (handle === p_Handle) {
    // Append stock status dynamically
    let statusText = Product_restock || "Sold Out"; // default to Sold Out if undefined
    $swatch.append('<span class="availability ' + statusText.replace(/\s/g,'').toLowerCase() + '" style="display: none;">' + statusText + '</span>');

    // Optional: Add class to main div if sold out
    if (statusText.toLowerCase() === "sold out") {
      $swatch.addClass("sold_out_main_div");
      $swatch.find("input").prop("disabled", true);
    }
  }
});
      // Update swatch availability
      if (Product_restock == "In-Stock") {
        $(`span[data-handle="${p_Handle}"]`).addClass("instock").text(Product_restock);
      } else if (Product_restock == "Pre-Order") {
        $(`span[data-handle="${p_Handle}"]`).addClass("preorder").text(Product_restock);
      } else {
        $(`span[data-handle="${p_Handle}"]`).addClass("outofstock").text(Product_restock);
      }

      if (Product_restock == "Sold Out") {
        $("#test_box_" + p_Handle).closest(".gpo-swatches.image-swatches").addClass("sold_out_main_div");
      }

      // Clean up
      $("body .apiData").remove();
    },
    error: function (error) {
      console.error("Error fetching product information:", error);

      // Hide link and disable swatch
      var $url = $(`[href="${only_url}"]`);
      $url.hide();

      var $swatch = $(`#test_box_${p_Handle}`).closest(".gpo-swatches");
      $swatch.css("pointer-events", "none");
      $(`#test_box_${p_Handle}`).prop("disabled", true);
    },
  });
}
  setTimeout(function () {
    clearInterval(GPOAddClass);
  }, 10000);
}
// cart page edit opetion sold product end